module.exports = __webpack_public_path__ + "static/media/water_level_4.807f1151.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/water_level_4.png
// module id = 312
// module chunks = 2